import { Box, Typography, Paper } from '@mui/material';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';

const AcessoNaoPermitido = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          padding: 4,
          maxWidth: 420,
          textAlign: 'center',
          borderRadius: 4,
          background: 'linear-gradient(135deg, #ffffff 0%, #f0f4ff 100%)',
        }}
      >
        <ReportGmailerrorredIcon sx={{ fontSize: 60, color: '#d32f2f', mb: 2 }} />

        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Acesso Não Permitido
        </Typography>

        <Typography variant="body1" color="text.secondary">
          O perfil em uso não possui permissão para acessar esta página.
        </Typography>
      </Paper>
    </Box>
  )
}

export default AcessoNaoPermitido
